import { RootState } from "@/store/types";

export const state: RootState = {
  redirectPath: null,
  pageNotFound: false,
};
